import { getEnv } from './get-env';

export type EnvName = 'local' | 'dev' | 'uat' | 'prod';
const isAppEnv = async (...envNames: EnvName[]) => {
    const env = await getEnv('DOCAPP_ENVIRONMENT', true);
    return env ? envNames.some((e) => e === env) : false;
};

export default isAppEnv;
